import type { ReactNode } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { OpsRequestQueue } from '../components/features/ops/OpsRequestQueue.js';

/**
 * @graph-node {Page}
 * @graph-stack product-innovation-lab
 * @graph-domain Operations
 * @graph-business ops キュー（調査者ビュー）。依頼者のいる依頼（scope=requests。システムオペレーションは システム運用 タブへ分け、ここには出さない）を「ID / 起票 / 緊急度 / SLO / 対応者 / 進捗 / 依頼」の表で一覧する。ステータス（All / Open / Investigating / Blocked / Closed）とサービスで絞り込み、検索ボックスで番号（#412 等）またはフリーワードをサーバ側で絞り込む（入力は IME 確定後にデバウンスして送る）。履歴含む全件を offset ページングでスクロール読み込みする（全件はロードしない）。ID / 起票 / 緊急度 / SLO の列見出しをクリックすると取得済みの行を昇順・降順で並び替える（絞り込みは維持し、未取得ページが残る間はその旨を注記する）。SLO 見出しの隣の ? から目標営業日の説明を開ける。ローディングはスケルトン、0 件は空表示（検索中は検索語つき）、失敗は再試行付きエラー表示にする
 * @graph-connects OpsRequestQueue [calls] 対象範囲 requests で一覧（ステータスタブ・サービス絞り込み・検索・並び替え）を描画
 */
export const Route = createFileRoute('/ops/')({
  component: OpsQueuePage,
});

/** @graph-connects OpsRequestQueue [calls] 対象範囲 requests の一覧 */
function OpsQueuePage(): ReactNode {
  return <OpsRequestQueue scope="requests" />;
}
